







import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-plus',
  components: {}
}

@Component(config)
export default class IconPlus extends Vue {}
